import { useRouteMatch } from 'react-router-dom'

import { useGetSchedulingLinkQuery } from 'root-api'

export const useSchedulingLink = () => {
  const { params } = useRouteMatch()
  const { data, isLoading } = useGetSchedulingLinkQuery(
    { uuid: params.linkUid },
    { skip: !params.linkUid }
  )

  if (isLoading) return undefined
  if (!data) return null
  return data
}
